import { FormEventHandler } from "react";
import modelReducer from "../../reducers/modelReducer";
import { Node, NodeType } from "../../types/Graph";
import { Path } from "../../types/Model";
import { pathListToObject } from "../../util/GraphUtil";
import { queryPaths } from "../../util/ModelUtil";
import { ButtonDefinition, ButtonList } from "../buttonPanel";
import Panel from "../panel";
import { MenuProps } from "./menuTypes";

const SelectionMenu = ({
  model,
  setModel,
  selection,
  setSelection,
  settings,
  setSetting,
}: MenuProps) => {
  const setSelectionCallback = () => {
    const name = prompt("Name?") ?? "";
    setSelection([name]);
  };
  const clearSelectionCallback = () => {
    setSelection([]);
  };
  const removeSelectedNodesCallback = () => {
    const newModel = modelReducer(model, {
      type: "REMOVE_NODES",
      data: selection,
    });
    setSelection([]);
    setModel(newModel);
  };
  const showBBToggleCallback: FormEventHandler<HTMLInputElement> = (
    event: React.FormEvent<HTMLInputElement>,
  ) => {
    setSetting("showSelectionBoundingBox", !event.currentTarget.checked);
  };
  const buttons: ButtonDefinition[] = [
    { label: "set selection", callback: setSelectionCallback },
    { label: "clear selection", callback: clearSelectionCallback },
    { label: "remove selection", callback: removeSelectedNodesCallback },
  ];
  const currentSelectionPaths = selection.reduce(
    (acc, s) => acc.concat(queryPaths([s, "*", "*"], model.paths)),
    [] as Path[],
  );
  const currentSelectionObject = pathListToObject(currentSelectionPaths);
  const currentSelectionNodes: Node[] = selection.map(
    (s) =>
      model.nodes.find((n) => n.name === s) ?? {
        name: `${s} not found`,
        position: { xpos: 0, ypos: 0 },
        type: NodeType.Entity,
      },
  );
  const currentSelection = (
    <span>
      {/* {currentSelectionNodes.map(n => `${n.name}- ${n.type}`).join(', ')} */}
      <div>
        paths:
        <br />
        <div style={{ marginLeft: 20 }}>
          <pre className="text-sm">
            {currentSelectionPaths
              .map((p) => p.join(" | "))
              .map((p) => (
                <>
                  {p}
                  <br />
                </>
              ))}
          </pre>
        </div>
      </div>
      {/* <div><pre className="text-sm">{JSON.stringify(currentSelectionObject, null, 2)}</pre></div> */}
    </span>
  );
  return (
    <Panel title="Selection">
      <ButtonList buttons={buttons} />
      <br />
      {currentSelection}
      <input
        type="checkbox"
        name="show_bounding_box"
        onChange={showBBToggleCallback}
        id="show-bounding-box"
        checked={settings.showSelectionBoundingBox}
      ></input>
      <label htmlFor="show_bounding_box" className="text-white">
        {" "}
        show bounding box
      </label>
    </Panel>
  );
};

export default SelectionMenu;
